import yemiPic from "@/public/images/artists/yemi.png";
import { Artist } from "@/types/types";

export const yemi = {
  id: "102",
  name: "Yemi",
  image: yemiPic,
  description: `Yemi, the Afrobeat singer, has a natural talent for rhythmic tunes and a beautiful tone that effortlessly charms the audience. Her music is a delightful blend of nice vibrato and a soothing voice, making her stand out in a crowd.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fyemi-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Afrobeat", "RnB", "Pop"],
      secondary: ["Singer", "Soothing"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 49,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
